import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=57e5ee17&scoped=true"
import script from "./PageSettings.vue?vue&type=script&lang=ts"
export * from "./PageSettings.vue?vue&type=script&lang=ts"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=57e5ee17&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5ee17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57e5ee17')) {
      api.createRecord('57e5ee17', component.options)
    } else {
      api.reload('57e5ee17', component.options)
    }
    module.hot.accept("./PageSettings.vue?vue&type=template&id=57e5ee17&scoped=true", function () {
      api.rerender('57e5ee17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/PageSettings.vue"
export default component.exports